import account from "./account.i18n"
import banner from "./banner.i18n"
import block from "./block.i18n"
import accountTables from "./accountTables.i18n"
import core from "./core.i18n"
import dapp from "./dapp.i18n"
import dashboard from "./dashboard.i18n"
import errors from "./errors.i18n"
import footer from "./footer.i18n"
import forum from "./forum.i18n"
import navbar from "./navbar.i18n"
import producer from "./producer.i18n"
import search from "./search.i18n"
import transaction from "./transaction.i18n"
import vote from "./vote.i18n"
import filters from "./filters.i18n"

export const en = {
  ...account,
  ...banner,
  ...accountTables,
  ...core,
  ...block,
  ...dapp,
  ...dashboard,
  ...errors,
  ...search,
  ...navbar,
  ...producer,
  ...transaction,
  ...vote,
  ...footer,
  ...forum,
  ...filters
}
